// extracted by mini-css-extract-plugin
export default {"button-area":"BoardWrite_button-area__9miju"};